module.exports = __webpack_public_path__ + "img/person3.0105f1dd.jpg";